import * as Yup from 'yup';

export const addressSchema = Yup.object().shape({
  address: Yup.string().required('Informe um endereço'),
  number: Yup.string().nullable(),
  complement: Yup.string().nullable(),
  neighborhood: Yup.string().nullable(),
  zipCode: Yup.string().nullable(),
  city: Yup.object()
    .shape({
      id: Yup.number().required('Cidade obrigatória'),
      name: Yup.string().required('Cidade obrigatória'),
    })
    .required('Cidade obrigatória')
    .typeError('Cidade inválida'),
  province: Yup.string().required('Estado obrigatório').typeError('Estado inválido'),
  country: Yup.object()
    .shape({
      id: Yup.number().required('País obrigatório'),
      name: Yup.string().required('País obrigatório'),
    })
    .required('País obrigatório')
    .typeError('País inválido'),
  client: Yup.object().optional().nullable()
    .shape({
      id: Yup.number().required('Cliente obrigatório'),
      social_name: Yup.string().required('Cliente obrigatório'),
    }),
  lat: Yup.number()
    .required('Selecione um logradouro utilizando o seletor do google')
    .typeError('Selecione um logradouro utilizando o seletor do google'),
  lng: Yup.number()
    .required('Selecione um logradouro utilizando o seletor do google')
    .typeError('Selecione um logradouro utilizando o seletor do google'),
  scheduledTime: Yup.string()
    .required('Você precisa informar uma data')
    .typeError('Data informada inválida'),
  startSchedule: Yup.string()
    .required('Você precisa informar uma data')
    .typeError('Data informada inválida'),
});
